"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FragmentsDevTools = void 0;
class FragmentsDevTools {
    overrideFragmentsInfo(fragmentsInfo, options) {
        try {
            for (const fragmentName in options) {
                if (!fragmentsInfo.hasOwnProperty(fragmentName)) {
                    continue;
                }
                const fragmentOverrideOptions = options[fragmentName];
                if (fragmentOverrideOptions.version) {
                    this.overrideFragmentVersion(fragmentsInfo[fragmentName], fragmentOverrideOptions.version);
                }
                if (fragmentOverrideOptions.host) {
                    this.overrideFragmentHost(fragmentsInfo[fragmentName], fragmentOverrideOptions.host);
                }
            }
        }
        catch (error) {
            console.error('[FragmentsLoader] Error while overriding fragments info', error);
        }
    }
    overrideFragmentHost(fragmentInfo, host) {
        fragmentInfo.files = fragmentInfo.files.map(file => `${host}/${new RegExp('^.*/(.*)?.*$').exec(file)[1]}`);
    }
    overrideFragmentVersion(fragmentInfo, version) {
        fragmentInfo.files = fragmentInfo.files.map(file => file.replace(new RegExp('^.*/(.*)/(?:.*)?.*$', 'ig'), (a, b) => a.replace(b, version)));
    }
}
exports.FragmentsDevTools = FragmentsDevTools;
